import { Injectable, inject } from '@angular/core';
import { GridOptions } from '../interfaces/grid-options';
import { getColumnTypes } from './column-types';
import { TranslateService } from '@ngx-translate/core';
import { FilterModelWithKeys } from '../interfaces/grid-context';
import { ColDef } from 'ag-grid-community';
import { Entity } from '@shared/constants/entity';
import {
  GetRowsRequest,
  RestApiService,
} from '@core/services/rest-api.service';
import { take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DropdownGridOptionsService {
  private translate = inject(TranslateService);
  private api = inject(RestApiService);

  clientSideMultiSelect(
    entity: Entity,
    colDefs: ColDef[],
    filterModel?: FilterModelWithKeys
  ): GridOptions {
    return {
      columnDefs: colDefs,
      columnTypes: getColumnTypes(this.translate),
      context: { entity, extraFilter: filterModel },
      onGridReady: event => {
        event.api.sizeColumnsToFit();
        event.api.setGridOption('quickFilterText', '');
        const colDefsWithField = colDefs.filter(c => c.field);
        const fields = colDefsWithField.map(c => c.field) as string[];
        let body: GetRowsRequest;
        if (filterModel !== undefined) {
          body = {
            entity: entity,
            fields: fields,
            filterModel,
          };
        } else {
          body = {
            entity: entity,
            fields: fields,
          };
        }

        this.api
          .getData(body)
          .pipe(take(1))
          .subscribe(({ data }) => {
            event.api.setGridOption('rowData', data);
          });
      },
      rowSelection: {
        mode: 'multiRow',
        enableSelectionWithoutKeys: true,
      },
    };
  }

  clientSideSingleSelect(
    entity: Entity,
    colDefs: ColDef[],
    filterModel?: FilterModelWithKeys
  ): GridOptions {
    return {
      columnDefs: colDefs,
      columnTypes: getColumnTypes(this.translate),
      context: { entity, extraFilter: filterModel },
      onGridReady: event => {
        event.api.sizeColumnsToFit();
        event.api.setGridOption('quickFilterText', '');
        const fields = colDefs.map(c => c.field) as string[];
        let body: GetRowsRequest;
        if (filterModel !== undefined) {
          body = {
            entity: entity,
            fields: fields,
            filterModel,
          };
        } else {
          body = {
            entity: entity,
            fields: fields,
          };
        }

        this.api
          .getData(body)
          .pipe(take(1))
          .subscribe(({ data }) => {
            event.api.setGridOption('rowData', data);
          });
      },
    };
  }
}
